// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
import { createEnumStyle } from "../EnumHelperFuncs";
export var OTelSamplingDecision = ( /* @__PURE__ */createEnumStyle({
    NOT_RECORD: 0 /* eOTelSamplingDecision.NOT_RECORD */,
    RECORD: 1 /* eOTelSamplingDecision.RECORD */,
    RECORD_AND_SAMPLED: 2 /* eOTelSamplingDecision.RECORD_AND_SAMPLED */
}));
//# sourceMappingURL=OTelSamplingDecision.js.map